import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import * as React from 'react';
import { userSelector } from '../../store/login/selector';
import styles from './CustomRoute.module.scss';
//redux
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
//redux states
import { RootState } from '../../store';
import { LoginState } from '../../store/login/reducer';
import { BounceLoader } from 'react-spinners';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
interface StateProps {
  user: any;
  loginState: LoginState;
}
interface OwnProps {
  component: any;
  path: string;
}

export const PrivateTipsterRoute: React.FC<
  StateProps & RouteComponentProps & OwnProps
> = ({ component: Component, user, loginState, ...rest }) => {
  const { t } = useTranslation();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!loginState.requested || loginState.isLoading) {
          return (
            <div className={styles.loader}>
              <BounceLoader color={'#6633ff'} size={25} />
              <p>{tr(t, 'loading')} ...</p>
            </div>
          );
        } else if (user) {
          if (user.is_tipster) {
            return <Component user={user} {...props} key={Date.now()} />;
          } else {
            return (
              <Redirect
                exact
                to={{
                  pathname: '/login',
                  state: { from: props.location },
                }}
              />
            );
          }
        } else {
          return (
            <Redirect
              exact
              to={{
                pathname: '/login',
                state: { from: props.location },
              }}
            />
          );
        }
      }}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
  loginState: state.login,
});

export const ConnectedPrivateTipsterRoute = withRouter(
  connect(mapStateToProps)(PrivateTipsterRoute),
);
